import { hasValue } from 'utils/hasValue';

// PEGO-14837 requires the download to be named after the report period; the
// backend filename is always `<uuid>.csv`, so the name is built client-side.
export const payinReportFilename = (
  createdAfter?: string,
  createdBefore?: string
) =>
  hasValue(createdAfter) && hasValue(createdBefore)
    ? `Payin Order report from ${createdAfter} to ${createdBefore}.csv`
    : 'Payin Order report.csv';
